module.exports = __webpack_public_path__ + "static/media/Phone-Cab.9534fc55.svg";